import React, { useState } from "react";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
const TITLE =
  "Calculatrice Circonférence du Cylindre - Calcul de la circonférence du cylindre";
const DESCRIPTION =
  "Calculatrice Circonférence du Cylindre - Calcul de la circonférence du cylindre pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "circonférence du cylindre calcul de la circonférence du cylindre, calculatrice circonférence du cylindre calcul de la circonférence du cylindre, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/cylinder-circumference";
function CylinderCircumferenceCalculator() {
  const [diameter, setDiameter] = useState("");
  const [height, setHeight] = useState("");
  const [circumference, setCircumference] = useState("");
  const [error, setError] = useState("");
  const [solutionSteps, setSolutionSteps] = useState([]);

  const handleCalculate = () => {
    if (!diameter || !height) {
      setError("Veuillez entrer le diamètre et la hauteur correctement");
      setCircumference("");
      return;
    }
    const generateSolutionSteps = (diameter, height, circumference) => {
      const steps = [];
      steps.push(
        `Étape 1 : Entrez le diamètre (${diameter}) et la hauteur (${height})`
      );
      steps.push(
        `Étape 2 : Calcul de la circonférence du cylindre par la formule : 2 × π × diamètre = 2 × π × ${diameter} = ${circumference}`
      );
      steps.push(`Étape 3 : La circonférence du cylindre a été calculée avec succès`);
      return steps;
    };
    const diameterValue = parseFloat(diameter);
    const heightValue = parseFloat(height);
    if (
      isNaN(diameterValue) ||
      isNaN(heightValue) ||
      diameterValue <= 0 ||
      heightValue <= 0
    ) {
      setError("Veuillez entrer des valeurs valides et positives pour le diamètre et la hauteur");
      setCircumference("");
      return;
    }
    const circumferenceValue = 2 * Math.PI * diameterValue;
    setCircumference(circumferenceValue.toFixed(2));
    const steps = generateSolutionSteps(
      diameterValue,
      heightValue,
      circumferenceValue.toFixed(2)
    );
    setSolutionSteps(steps);
    setError("");
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "18px" }}>Comment calculer la circonférence du cylindre</h2>
                <p>
                  Pour calculer la circonférence du cylindre, vous devez entrer le diamètre
                  et la hauteur. La circonférence est ensuite calculée par la formule suivante :
                </p>
                <p>Circonférence du cylindre = 2 × π × diamètre</p>
                <p>
                  Vous pouvez utiliser cette calculatrice pour obtenir la circonférence
                  du cylindre à partir des valeurs saisies.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div>
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label className="form-label me-2">Diamètre</label>
                    </b>
                    <input
                      type="number"
                      placeholder="Diamètre"
                      value={diameter}
                      onChange={(e) => setDiameter(e.target.value)}
                      className="form-control"
                      style={{ width: "90%" }}
                    />
                  </div>
                  <br />
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label className="form-label me-2">Hauteur</label>
                    </b>
                    <input
                      type="number"
                      placeholder="Hauteur"
                      value={height}
                      onChange={(e) => setHeight(e.target.value)}
                      className="form-control"
                      style={{ width: "90%" }}
                    />
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={handleCalculate}
                  >
                    Calculer la circonférence
                  </button>
                </div>
                <br />
                <div>
                  {error !== "" ? (
                    <p className="p-3 mb-2 bg-warning text-white">
                      Erreur : {error}
                    </p>
                  ) : (
                    <>
                      {circumference !== "" && (
                        <>
                          <p className="p-3 mb-2 bg-success text-white">
                            Circonférence du cylindre : {circumference}
                          </p>
                          <div className="p-3 mb-2 bg-info">
                            <b>Étapes de résolution</b>
                            <ol>
                              {solutionSteps.map((step, index) => (
                                <li key={index}>{step}</li>
                              ))}
                            </ol>
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default CylinderCircumferenceCalculator;
